<template>
  <div class="ride-where-to-private main" v-if="workflow">
    <div class="wrapper">
      <img :src="vehicleIcon" @click="clearPrivateTransport" />
      <h1 class="subtitle">
        <i
          class="fa fa-chevron-left"
          style="padding-right: 8px"
          @click="$emit('close')"
        />
        <span @click="gotoBusinessProfile">{{ workflow.business.name }}</span>
      </h1>

      <div style="display: flex; margin-top: -10px">
        <div class="left">
          <p>
            <i class="fa fa-circle has-text-info pulse" />
          </p>
          <p>
            <i class="fa fa-ellipsis-v fa-sm" style="color: grey" />
          </p>
          <p>
            <i class="fa fa-map-marker-alt has-text-success" />
          </p>
        </div>
        <div class="right" :class="{ wider: showWider }">
          <div class="field">
            <p v-if="allowFreeStop" class="control has-icons-right">
              <input
                ref="pickup"
                v-model="pickupInput"
                class="input is-medium has-text-link"
                :class="{ 'is-rounded': !showWider }"
                :style="settingStyle('pickup')"
                :placeholder="$t('ride.pickup-at')"
                @focus="
                  pickup = null;
                  pickupInput = null;
                  setting = 'pickup';
                "
                @blur="
                  checkResetPickup();
                  showWider = false;
                "
                @keydown="showWider = true"
                @keyup="checkInput"
              />
              <span class="icon is-small is-right">
                <i v-if="pickup" class="fa fa-check" />
                <i v-else class="fa fa-spinner fa-spin" />
              </span>
            </p>
            <p v-else class="control has-icons-right">
              <!-- :value="workflow.business.name" -->
              <input
                class="input is-medium has-text-link is-readonly"
                :class="{ 'is-rounded': !showWider }"
                v-model="pickupInput"
                :placeholder="$t('ride.select-pickup-stop')"
                readonly
                @focus="pickupInput = null"
                @click="
                  showPickStopHint = true;
                  pickup = null;
                  setting = 'pickup';
                "
              />
              <span class="icon is-small is-right">
                <i v-if="pickup" class="fa fa-check" />
                <i v-else class="fa fa-spinner fa-spin" />
              </span>
            </p>
          </div>
          <div class="field">
            <p v-if="isFixedDropoff" class="control has-icons-right">
              <input
                class="input is-medium has-text-dark fixed-stop"
                :class="{ 'is-rounded': !showWider }"
                :value="workflow.business.name"
                readonly
                @click="showOneWayHint = true"
              />
              <span class="icon is-small is-right">
                <i class="fa fa-lock" />
              </span>
            </p>
            <p v-else class="control has-icons-right">
              <input
                ref="dropoff"
                v-model="dropoffInput"
                class="input is-medium has-text-info"
                :class="{ 'is-rounded': !showWider }"
                :style="settingStyle('dropoff')"
                placeholder="Destination"
                @focus="
                  dropoff = null;
                  dropoffInput = null;
                  setting = 'dropoff';
                "
                @blur="showWider = false"
                @keydown="showWider = true"
                @keyup="checkInput"
              />
              <span class="icon is-small is-right">
                <i v-if="dropoff" class="fa fa-check" />
                <i v-else class="fa fa-search" />
              </span>
            </p>
          </div>
        </div>
      </div>

      <div
        v-if="showOneWayHint"
        class="notes-wrapper has-text-link"
        @click="showOneWayHint = false"
      >
        <i class="fa fa-info-circle" />&nbsp;<i>{{
          $t("ride.one-way-transport-hint")
        }}</i>
        <i class="fa fa-times-circle is-pulled-right" />
      </div>
      <div
        v-if="showPickStopHint"
        class="notes-wrapper has-text-success"
        @click="showPickStopHint = false"
      >
        <i class="far fa-hand-point-down" />&nbsp;<i>{{
          $t("ride.pick-stop-hint")
        }}</i>
        <i class="fa fa-times-circle is-pulled-right" />
        <!-- <button class="delete is-pulled-right" /> -->
      </div>
      <div
        v-if="showStopWarning"
        class="notes-wrapper has-text-danger single-line no-scrollbar"
        @click="showStopWarning = false"
      >
        <i class="fa fa-exclamation-triangle" />&nbsp;<i
          >{{ $t("ride.you-are-far-from-stops") }}
          <span>~{{ warningDistanceKM }}km</span>
        </i>
        <!-- <i class="fa fa-times-circle is-pulled-right" /> -->
      </div>

      <div v-if="pickup && dropoff">
        <div
          v-if="warning"
          class="notes-wrapper has-text-danger"
          @click="tryAgain"
        >
          <i class="fa fa-exclamation-triangle" />&nbsp;{{ warning }}
        </div>
        <div v-else-if="showNotes" class="notes-wrapper">
          <p @click="toggleEditNotes">
            <i
              class="fa fa-pencil-alt has-text-info is-pulled-right"
              style="margin-top: 3px; opacity: 0.7"
            />
            <i>{{ $t("ride.pickup-notes") }}</i>
          </p>
          <textarea
            ref="notes"
            v-show="editNotes"
            class="textarea"
            :placeholder="$t('ride.message-for-driver')"
            rows="2"
            v-model="notes"
          ></textarea>
          <p
            v-show="!editNotes && notes"
            class="has-text-success"
            @click="editNotes = true"
          >
            {{ notes }}
          </p>
        </div>
        <div
          v-if="warning"
          class="notes-wrapper has-text-primary"
          @click="tryAgain"
        >
          <i class="fa fa-undo-alt fa-lg" />
          {{ $t("ride.edit-locations-try-again") }}
        </div>
        <div v-else class="fare-wrapper">
          <i class="fare-word">{{ $t("fare") }}</i>
          <span v-if="isFree" class="free-word">{{ $t("free") }}</span>
          <span v-else>
            <span class="button is-white has-text-link has-text-weight-bold">
              {{ currency }}{{ fare }}
            </span>
            <span class="button is-light">{{ $t("cash") }}</span>
          </span>
          <span class="is-pulled-right submit pulse-btn" @click="submit">
            <!-- {{ $t("ride.request-pickup") }} -->
            {{ $t("ride.book") }}
            &nbsp;<i class="fa fa-chevron-right fa-lg" />
          </span>
        </div>

        <div style="margin-top: 10px">
          <RideDetailsMap
            :pickup="pickup"
            :dropoff="dropoff"
            :showRoute="!warning"
            :route="drivingRoute"
            :tall="!warning && !showOneWayHint"
            :key="drivingRoute"
          />
        </div>
      </div>
      <div v-else>
        <div
          v-if="allowFreeStop"
          class="buttons is-flex"
          style="margin-top: 15px; margin-bottom: 0px"
        >
          <span
            class="button"
            :class="{ 'greyed-out': settingDropoff }"
            @click="currentLocationClick"
            v-ripple
          >
            <i class="fa fa-circle has-text-info fa-sm pulse" />
            <i style="margin-left: 8px">{{
              $t("passenger.current-location")
            }}</i>
          </span>
          <span class="button" @click="chooseOnMap">
            <i class="fa fa-globe-asia has-text-info" />
            <i style="margin-left: 8px">{{ $t("ride.choose-on-map") }}</i>
          </span>
        </div>
        <div v-else style="margin-top: 15px" />

        <div class="list-wrapper no-scrollbar" v-on:scroll.passive="hideHints">
          <div class="list">
            <span
              v-for="(l, i) in yourLocations"
              :key="i"
              class="list-item"
              :class="{ 'pulse-stop': pulseAutoSelect && i === 0 }"
              @click="chooseFrequentLocation(l)"
              v-ripple
            >
              <span class="stop-name no-scrollbar">
                <i class="fa fa-map-marker-alt fa-sm" style="opacity: 0.7" />
                {{ shortenString(l.name, 35) }}
              </span>
              <span
                v-if="l.distance < 10000"
                class="distance is-pulled-right"
                >{{ l.distancePretty }}</span
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <fade-transition>
      <RideSetLocation
        v-if="showLocationMap"
        :stopType="setting"
        @setLocation="setLocation"
        @close="showLocationMap = false"
      />
    </fade-transition>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";
import vehicles from "@/vehicles";
import geo from "@/geo";

import RideSetLocation from "@/components/RideSetLocation.vue";
import RideDetailsMap from "@/components/RideDetailsMap.vue";

export default {
  name: "RideWhereToPrivate",
  components: {
    RideSetLocation,
    RideDetailsMap,
  },
  props: {
    workflow: Object, // transport workflow, should be array
  },
  data() {
    return {
      autocomplete: null,
      pickupInput: null,
      dropoffInput: null,
      pickup: null,
      dropoff: null,
      setting: null, // "pickup" or "dropoff"
      timer: 0,
      showWider: false,
      notes: null,
      editNotes: false,
      showLocationMap: false,
      warning: null,
      drivingDist: null,
      drivingRoute: null,
      fare: null,
      warningDistanceKM: null,
      showStopWarning: false,
      showOneWayHint: false,
      showPickStopHint: true,
      // oneWayHint: "This transport only goes one-way",
      // pickStopHint: "Pick a stop from the list below",
      pulseAutoSelect: false,
    };
  },
  computed: {
    currentLocation() {
      return this.$t("passenger.current-location");
    },
    pinLocation() {
      return this.$t("ride.pin-location");
    },
    pickupName() {
      if (!this.pickup) return null;
      if (this.pickup.current_location && this.pickup.name) {
        if (this.timer % 2 && this.pickup.name) return this.pickup.name;
        else return `${this.currentLocation} - ${this.pickup.name}`;
      }
      if (this.pickup.current_location) {
        return this.currentLocation;
      }
      return this.pickup.name || this.pinLocation;
    },
    dropoffName() {
      if (!this.dropoff) return null;
      return this.dropoff.name || this.pinLocation;
    },
    settingPickup() {
      return this.setting === "pickup";
    },
    settingDropoff() {
      return this.setting === "dropoff";
    },
    workflowStops() {
      return this.workflow.data.stops;
    },
    yourLocations() {
      if (this.workflowStops) return this.workflowStops;
      else return this.$store.state.userStops.filter((s) => s.name); // filter blank string names
    },
    vehicleIcon() {
      return vehicles.img(this.workflow.name);
    },
    feePerKM() {
      if (!this.workflow.data) return 20;
      return this.workflow.data.fee_per_km || 15; // default to 15 baht per km
    },
    minFare() {
      if (!this.workflow.data) return 20;
      return this.workflow.data.min_fare || 15; // default to 15 baht min fare
    },
    currency() {
      return this.currencySymbol("th");
    },
    allowFreeStop() {
      if (!this.workflow) return false;
      return this.workflow.data.any_location;
    },
    showNotes() {
      return false;
    },
    isFixedDropoff() {
      return true; // currently all private are fixed dropoff
    },
    fixedDropoff() {
      return {
        name: this.workflow.business.name,
        lat: this.workflow.business.lat,
        lon: this.workflow.business.lon,
      };
    },
    isFree() {
      return true; // most private will be free
    },
    country() {
      return this.workflow.business.country;
    },
  },
  mounted() {
    var url = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    if (this.allowFreeStop) {
      $Scriptjs(url, () => this.setupAutocomplete());

      // setTimeout(() => this.$refs.dropoff.focus(), 400);
      // this.setPickup(null);
    }

    // this.setting = "dropoff"; // default: pickup is your current location, so set dropoff
    if (this.isFixedDropoff) {
      this.setDropoff(this.fixedDropoff);
      this.setting = "pickup"; // if fixed dropoff then set pickup
    }

    this.sortStops();
    // this.oscillatePickupInput();
  },
  methods: {
    hideHints() {
      this.showOneWayHint = false;
      this.showPickStopHint = false;
    },
    oscillatePickupInput() {
      setInterval(() => {
        this.timer += 1;
        if (this.pickupName) this.pickupInput = this.pickupName;
      }, 2000);
    },
    gotoBusinessProfile() {
      if (!this.isSuperUser()) return;
      this.goto("/business_profile/" + this.workflow.business_id);
    },
    currentLocationClick() {
      this.setPickup(null);
      this.next();
    },
    clearPrivateTransport() {
      this.infoToast("clearPrivateTransport");
      this.$store.commit("setPrivateTransport", null);
      this.$emit("clearSelected");
      this.$emit("close");
    },
    sortStops() {
      var userCoords = this.$store.getters.getUserLatLon;
      var stops = this.workflowStops;
      stops.forEach((s) => {
        s.distance = geo.distanceToUserInMeters(s, userCoords);
        s.distancePretty = geo.prettyDistance(s.distance);
      });
      stops.sort((a, b) => {
        return a.distance - b.distance;
      });
      if (stops[0].distance < 100) {
        this.pulseAutoSelect = true;
        if (this.closestStopIsPickupAndDropoff(stops[0])) return;
        if (!this.allowFreeStop) {
          setTimeout(() => this.setPickup(stops[0]), 3000); // auto select closest stop as pickup
        }
      }
      if (stops[0].distance >= 1000) {
        this.showStopWarning = true;
        this.warningDistanceKM = Math.round(stops[0].distance / 1000); // km
      }
    },
    closestStopIsPickupAndDropoff(pickup) {
      if (!this.dropoff) return false;
      return pickup.name === this.dropoff.name;
    },
    next() {
      setTimeout(() => {
        if (this.settingPickup) this.$refs.dropoff.focus();
      }, 400);
    },
    tryAgain() {
      //   this.dropoff = null;
      //   this.setting = "dropoff";
      this.pickup = null;
      this.setting = "pickup";
    },
    settingStyle(val) {
      if (this.setting !== val) return null;
      return `background-color: #f1ffed`;
    },
    toggleEditNotes() {
      this.editNotes = !this.editNotes;
      if (this.editNotes) {
        setTimeout(() => this.$refs.notes.focus(), 300);
      }
    },
    checkInput(e) {
      console.log("checkInput", e.target.value);
      if (!e.target.value.length) this.showWider = false;
    },
    chooseOnMap() {
      this.showLocationMap = true;
    },
    chooseFrequentLocation(stop) {
      setTimeout(() => {
        if (this.settingDropoff) this.setDropoff(stop);
        else this.setPickup(stop);
      }, 300);
    },
    checkResetPickup() {
      setTimeout(() => {
        if (!this.pickup && !this.showLocationMap) this.setPickup(null);
      }, 1000);
    },
    setDropoff(stop) {
      this.dropoff = stop;
      this.dropoffInput = this.dropoffName;
      this.setting = null;
      this.checkFare();
    },
    setPickup(stop) {
      if (stop) this.pickup = stop;
      else {
        var coords = this.$store.getters.getUserLatLon;
        this.pickup = {
          current_location: true,
          name: "", // "Pin Location",
          lat: coords.lat,
          lon: coords.lon,
        };
        this.reverseGeocode(coords);
      }
      this.pickupInput = this.pickup.name || this.currentLocation; //"Current Location";
      if (!this.dropoff) this.next();
      else this.setting = null;
      this.checkFare();
    },
    closeHints() {
      this.showOneWayHint = false;
      this.showPickStopHint = false;
      this.showStopWarning = false;
    },
    checkFare() {
      this.warning = null; // clear
      if (!this.pickup || !this.dropoff) return;
      this.closeHints();
      if (this.invalidTripDistance()) return; // estimated distance
      if (this.invalidPickupLocation()) return;
      // now compute actual driving route if possible for fare
      this.getDrivingRouteAndSetFare();
      //   this.fare = Math.round((this.feePerKM * this.drivingDist) / 1000);
      //   if (this.fare < this.minFare) this.fare = this.minFare;
    },
    setFare() {
      this.fare = Math.round((this.feePerKM * this.drivingDist) / 1000);
      if (this.fare < this.minFare) this.fare = this.minFare;
    },
    getDrivingRouteAndSetFare() {
      var o = { pickup: this.pickup, dropoff: this.dropoff };
      this.$store
        .dispatch("drivingRoute", o)
        .then((obj) => {
          this.console("getDrivingRoute", obj);
          this.drivingDist = obj.distance; // update to actual driving distance
          this.drivingRoute = obj.encoded;
          // this.drawDrivingRoute(obj.encoded);
        })
        .catch((err) => console.error("drivingRoute error", err))
        .finally(() => this.setFare());
    },
    invalidTripDistance() {
      var dist = geo.distanceToUserInMeters(this.pickup, this.dropoff);
      this.drivingDist = dist * 1.25; // estimated driving distance
      if (this.drivingDist < 50) {
        this.warning = this.$t("ride.locations-too-close-together"); //`Locations are too close together`;
        return true;
      }
      if (this.drivingDist < 25000) return false; // okay, it's not invalid, check max dist on workflow
      this.warning = `Maximum trip distance is 25km`; // depends on workflow
      return true;
    },
    invalidPickupLocation() {
      if (this.pickup.number) return false; // fixed stops have a number field, starting with 1
      var dist = geo.distanceToUserInMeters(
        this.pickup,
        this.workflow.business
      );
      if (dist < 1000) return false; // okay it's inside area
      this.warning = "Outside pickup area for this fleet";
      return true;
    },
    // insideFreeDeliveryPolygon() {
    //   if (!this.freeDeliveryPolygon) return false;
    //   if (!this.address) return false;
    //   var gju = require("geojson-utils");
    //   var lat = this.address.lat;
    //   var lon = this.address.lon;
    //   var point = { type: "Point", coordinates: [lon, lat] };
    //   var polygon = { type: "Polygon", coordinates: this.freeDeliveryPolygon };
    //   if (gju.pointInPolygon(point, polygon)) {
    //     return true;
    //   }
    //   return false;
    // },
    reverseGeocode(coords) {
      this.$store
        .dispatch("reverseGeocode", coords)
        .then((res) => {
          this.console("reverseGeocode", res);
          //   this.streetName = res.data.address.road;
          //   if (this.addressName === "") this.locationInput = this.streetName;
          //   this.emitLocation(coords);
          this.pickup.name = res.data.address.road; // TODO translate
          if (this.pickup.current_location) {
            this.pickupInput += ` - ${this.pickup.name}`;
          }
        })
        .catch((err) => console.error("reverseGeocode error", err));
    },
    setLocation(val) {
      this.showLocationMap = false;
      this.console("setLocation", val);
      if (val.stop_type === "pickup") {
        if (!val.name) val.name = "Pin Location";
        this.setPickup(val);
        // check if valid pickup, e.g. not too close to a win, not outside of pickup area
        // this.pickup = {
        //   name: val.name,
        //   lat: val.lat,
        //   lon: val.lon,
        // };
        // this.pickupInput = val.name;
        // if (this.validSpecialStop(this.pickup)) this.confirmPickup();
        // else this.pickup = null;
      } else {
        if (!val.name) val.name = "Pin Location";
        this.setDropoff(val);
        // check if valid dropoff, e.g. not too far
        // this.dropoff = {
        //   name: val.name,
        //   lat: val.lat,
        //   lon: val.lon,
        // };
        // this.dropoffInput = val.name;
      }
      //   if (this.invalidDropoff()) return;
    },
    setupAutocomplete() {
      this.initGoogle("pickup");
      if (!this.isFixedDropoff) this.initGoogle("dropoff");
    },
    initGoogle(ref) {
      var opts = {
        types: [],
        componentRestrictions: { country: this.country },
      };
      var el = this.$refs[ref];
      var autocomplete = new window.google.maps.places.Autocomplete(el, opts);
      this.geolocate(autocomplete); // will bias google places to current location

      autocomplete.addListener("place_changed", () => {
        var place = autocomplete.getPlace();
        var stop = {
          name: place.name,
          lat: place.geometry.location.lat(),
          lon: place.geometry.location.lng(),
        };
        if (ref === "pickup") this.setPickup(stop);
        else this.setDropoff(stop);
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate(autocomplete) {
      if (!this.$store.getters.getUserLocation) return;
      var coords = {
        lat: this.$store.getters.getUserLocation[0],
        lng: this.$store.getters.getUserLocation[1],
      };
      var circle = new google.maps.Circle({ center: coords, radius: 25000 });
      autocomplete.setBounds(circle.getBounds());
    },
    submit() {
      this.createTransaction();
    },
    createTransaction() {
      var w = this.workflow;
      var fare = {
        version: "v1",
        price: this.fare, // show driver
        discount: 0, // show customer
        cash: this.fare, // cash + tukpay = price
        tukpay: 0, // free to play around with this
        distance: this.drivingDist,
      };
      var data = {
        pickup_stop: this.pickup,
        dropoff_stop: this.dropoff,
      };
      if (this.drivingRoute) data.predicted_route = this.drivingRoute;
      // other options: nearby_stations, agent
      if (!this.isFree) data.fare = fare;
      var loader = this.loadingDots("gold");
      this.$store
        .dispatch("createTransactionNearby", {
          workflow_id: w.id,
          workflow_type_name: w.workflow_type_name,
          business_id: w.business.id,
          created_by: this.$store.state.user.id,
          handled_by: null, //this.$store.state.selectedDriver,
          data: data,
        })
        .then((res) => {
          this.updateTransactionsForCustomer(false);
          this.$swal({
            title: this.$t("transport.waiting-for-confirmation"),
            showConfirmButton: false,
            timer: 2000,
          });
          this.$emit("close"); // this.closeModal();
          // this.goto("tuktuk");
          this.goto("/ride_booking/" + res.data.id); // transaciton id
        })
        .catch((err) => {
          this.console("public tuk tuk book error", err);
          if (err.message === "No worker exists") {
            this.warningAlert("No drivers are currently available");
          } else this.apiError(err);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: azure;
  /* background-color: whitesmoke; */
  z-index: 21;
  /* random z-index higher than modal */
  overflow: hidden;
}
.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
}
.table-wrapper {
  overflow: scroll;
  max-height: calc(100vh - 85px);
}
.table {
  margin-bottom: 10px;
}
.subtitle {
  opacity: 0.55;
  color: black;
  font-weight: 450;
  /* margin-left: 45px; */
  margin-top: 6px;
}
.key {
  font-weight: 550;
  color: rgba(84, 84, 84, 0.7);
  padding-right: 0;
}
input::-webkit-input-placeholder {
  /* color: #2693da !important; */
  font-weight: 500;
  /* opacity: 0.8;   */
  color: rgb(0, 198, 69);
  font-style: italic;
}
.left {
  height: 80px;
  width: 30px;
  margin-top: 6px;
}
.right {
  width: calc(100vw - 30px);
}
.left p {
  width: 20px;
  text-align: center;
  padding: 3px;
}
.notes-wrapper {
  padding: 10px;
  margin-top: 10px;
  background-color: white;
  border-radius: 3px;
  border: 1px solid #eee;
}
.fare-wrapper {
  padding: 4px 10px;
  margin-top: 10px;
  background-color: white;
  border-radius: 3px;
  border: 1px solid #eee;
}
.submit {
  position: absolute;
  right: 12px;
  margin-top: -4px;
  padding: 10px 15px;
  /* background-color: #00d1b2; */
  background-color: #24d168;
  color: white;
  /* font-size: 1.em; */
  font-weight: 500;
  /* #35AC5E #00D1B2 */
  border-radius: 10px;
}
.wider {
  position: absolute;
  left: 0;
  width: 100vw;
  /* padding: 0 5px; */
}
.fare-word {
  display: inline-block;
  margin: 6px 0;
  font-weight: 500;
}
.free-word {
  display: inline-block;
  margin: 6px 10px;
  font-weight: 550;
  color: #00d1b2;
  text-transform: uppercase;
}
.fa-times-circle {
  margin-top: 3px;
  opacity: 0.7;
  color: grey;
}
img {
  position: absolute;
  right: 12px;
  height: 35px;
  padding: 1px;
  border-radius: 3px;
  z-index: 22;
}
.fixed-stop {
  background-color: rgb(237, 237, 237);
}
.distance {
  font-size: 0.8em;
  font-weight: 550;
  opacity: 0.4;
  margin-top: 3px;
}
.pulse {
  font-size: 0.8em;
  border-radius: 50%;
  animation: shadow-pulse 2s 999;
}
.list-wrapper {
  height: calc(100vh - 200px);
  overflow: auto;
  padding-bottom: 56px;
}
.list-wrapper .list {
  margin: 1px;
}
.list-item {
  padding: 12px;
}
.is-flex {
  white-space: nowrap !important;
}
.is-flex .button {
  flex: 1;
  justify-content: flex-start;
  /* text-overflow: ellipsis; */
  /* max-width: 45vw; */
}
.greyed-out {
  opacity: 0.7;
}
.stop-name {
  display: inline-block;
  max-width: calc(100vw - 100px);
  white-space: nowrap;
  overflow: auto;
  vertical-align: bottom;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px cyan;
  }
  100% {
    box-shadow: 0 0 0 4px rgba(0, 255, 255, 0.4);
  }
}
.pulse-btn {
  animation: shadow-pulse-gold 2s ease-out infinite;
  border-radius: 3px;
}
.pulse-stop {
  animation: shadow-pulse-green 2s ease-out infinite;
  border-radius: 20px;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }
  50% {
    box-shadow: inset 0 0 0 6px rgba(255, 255, 0, 0.7);
  }
  100% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }
}
@keyframes shadow-pulse-green {
  0% {
    box-shadow: inset 0 0 0 0px lightgreen;
  }
  50% {
    box-shadow: inset 0 0 0 6px rgba(144, 238, 144, 0.5);
  }
  100% {
    box-shadow: inset 0 0 0 0px rgba(144, 238, 144, 1);
  }
}
</style>

<style lang="scss">
// puts the google places autocomplete dropdown results above this modal
// #ride-where-to-autocomplete {
.pac-container {
  z-index: 1101 !important;
}
// }
</style>